import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="bg-zinc-950 text-white min-h-screen">
      <div className="container mx-auto max-w-4xl px-4 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center text-amber-500 hover:text-amber-400 mb-8"
        >
          <ArrowLeft className="mr-2" size={20} />
          Torna alla Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-8">
          Privacy <span className="text-amber-500">Policy</span>
        </h1>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">1. Titolare del Trattamento</h2>
            <p>
              Il Titolare del trattamento dei dati è Roger'S Club Barberia, con sede in Via Tanzini, 41 - 50065 Pontassieve (FI), P.IVA 07183440481.
            </p>
            <p className="mt-2">
              Per qualsiasi informazione relativa al trattamento dei dati personali, è possibile contattarci al numero +39 331 885 7252.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">2. Tipologie di Dati Raccolti</h2>
            <p>
              Fra i Dati Personali raccolti da questo sito web, in modo autonomo o tramite terze parti, ci sono: dati di utilizzo, cookie e dati comunicati dall'utente.
            </p>
            <p className="mt-2">
              I Dati Personali possono essere liberamente forniti dall'Utente o, nel caso di Dati di Utilizzo, raccolti automaticamente durante l'uso di questo sito web.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">3. Finalità del Trattamento</h2>
            <p>I Dati dell'Utente sono raccolti per le seguenti finalità:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Contattare l'Utente</li>
              <li>Gestione delle richieste di prenotazione</li>
              <li>Statistica e analisi del traffico</li>
              <li>Visualizzazione di contenuti da piattaforme esterne</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">4. Base Giuridica del Trattamento</h2>
            <p>
              Il Titolare tratta Dati Personali relativi all'Utente in caso sussista una delle seguenti condizioni:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>L'Utente ha prestato il consenso per una o più finalità specifiche</li>
              <li>Il trattamento è necessario all'esecuzione di un contratto con l'Utente</li>
              <li>Il trattamento è necessario per adempiere un obbligo legale</li>
              <li>Il trattamento è necessario per il perseguimento del legittimo interesse del Titolare</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">5. Modalità di Trattamento</h2>
            <p>
              Il Titolare adotta le opportune misure di sicurezza volte ad impedire l'accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali.
            </p>
            <p className="mt-2">
              Il trattamento viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con logiche strettamente correlate alle finalità indicate.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">6. Conservazione dei Dati</h2>
            <p>
              I Dati sono trattati e conservati per il tempo richiesto dalle finalità per le quali sono stati raccolti. I Dati Personali raccolti per scopi collegati all'esecuzione di un contratto saranno trattenuti sino a quando sia completata l'esecuzione di tale contratto.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">7. Diritti dell'Utente</h2>
            <p>Gli Utenti possono esercitare determinati diritti con riferimento ai Dati trattati dal Titolare:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Revocare il consenso in ogni momento</li>
              <li>Opporsi al trattamento dei propri Dati</li>
              <li>Accedere ai propri Dati</li>
              <li>Verificare e chiedere la rettifica</li>
              <li>Ottenere la limitazione del trattamento</li>
              <li>Ottenere la cancellazione dei propri Dati Personali</li>
              <li>Proporre reclamo all'autorità di controllo</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">8. Modifiche alla Privacy Policy</h2>
            <p>
              Il Titolare del Trattamento si riserva il diritto di apportare modifiche alla presente privacy policy in qualunque momento notificandolo agli Utenti su questa pagina. Si prega dunque di consultare spesso questa pagina.
            </p>
          </section>

          <section className="border-t border-zinc-800 pt-8">
            <p className="text-sm text-gray-500">
              Ultimo aggiornamento: Febbraio 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
